import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import useFetchBusinesses from '../../hooks/useFetchBusinesses';
import useBusinessStore from '../../state/businessStore';
import { fetchBusinessActiveModules } from '../../api/business';

import Lucci from '../../assets/Logo.svg';
import SettingsIcon from '../../assets/icons/Settings_Business.svg';
import AddIcon from '../../assets/icons/Add_Business.svg';

import CreateBusinessModal from '../../partials/business/CreateBusinessModal';

import './BussinesMobileMenu.scss';

const BusinessmobileMenu = () => {
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);

  //:: State management with Zustand
  const { businesses, selectedBusiness, setSelectedBusiness, setActiveModules } =
    useBusinessStore();

  //* Loading businesses though the hook
  useFetchBusinesses();

  // Define colors to use for repeated initials
  const colors = ['#FF8000', '#008195', '#929292', '#AC5600', '#535353'];

  // Function to check for duplicates and assign colors
  const getInitialColor = (initial, index) => {
    // Filter businesses with the same initial
    const duplicates = businesses.filter(
      (x) => x.name && x.name[0].toUpperCase() === initial
    );

    if (duplicates.length > 1) {
      const colorIndex = index % colors.length;
      return colors[colorIndex];
    }

    return '#FF8000';
  };

  const handleBusinessSelect = async (businessId) => {
    setSelectedBusiness(businessId);
    const modules = await fetchBusinessActiveModules(businessId);
    setActiveModules(modules);
    navigate('/');
  };

  const handleAddBusiness = () => {
    setShowModal(true);
  };

  const handleSettings = () => {
    navigate('/business');
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div className="business-mobile-menu">
      <div className="business-mobile-menu__logo">
        <Link to="/">
          <img src={Lucci} alt="Lucci AI logo" />
        </Link>
      </div>
      <div className="business-mobile-menu__businesses">
        {businesses.map((business, index) => {
          const initial = business.name ? business.name[0].toUpperCase() : '';
          const bgColor = getInitialColor(initial, index);

          return (
            <button
              key={business.id}
              className={`business-mobile-menu__business-button ${
                selectedBusiness === business.id ? 'selected' : ''
              }`}
              onClick={() => handleBusinessSelect(business.id)}
              title={business.name}
            >
              {business.logoUrl ? (
                <img
                  src={business.logoUrl}
                  alt={business.name}
                  onError={() => {
                    console.error(
                      `Error loading image for ${business.name}: ${business.logoUrl}`
                    );
                  }}
                />
              ) : (
                <div
                  className={`business-mobile-menu__business-avatar ${
                    selectedBusiness === business.id ? 'selected' : ''
                  }`}
                >
                  <div
                    className="avatar-placeholder"
                    style={{ backgroundColor: bgColor }}
                  >
                    {initial}
                  </div>
                </div>
              )}
            </button>
          );
        })}
      </div>

      <div className="business-mobile-menu__actions">
        <button
          className="business-mobile-menu__action-button"
          onClick={handleAddBusiness}
        >
          <img src={AddIcon} alt="Add Business" />
        </button>
        <button
          className="business-mobile-menu__action-button"
          onClick={handleSettings}
        >
          <img src={SettingsIcon} alt="Settings" />
        </button>
      </div>

      <CreateBusinessModal isOpen={showModal} onClose={handleCloseModal} />
    </div>
  );
};

export default BusinessmobileMenu;
